import React, { useContext, useEffect, useState } from "react"
import MicrocopyContext from "~contexts/MicrocopyContext"
import { OutboundLink } from "gatsby-plugin-gtag"
import { selectContent } from "~utils/analytics"

import {
  FiChevronDown,
  FiChevronRight,
  FiRss,
  FiSquare,
  FiCheckSquare,
  FiCircle,
  FiCheckCircle,
} from "react-icons/fi"
import * as style from "./Filters.module.scss"

const Filters = ({ engine, mobile = false }) => {
  const microcopy = useContext(MicrocopyContext)
  const [expanded, setExpanded] = useState(true)

  useEffect(() => setExpanded(false), [])

  const event = (id) => () => selectContent(`Changelog - RSS (${id})`)

  return (
    <>
      <div>
        <a
          className={style.toggle}
          onClick={() => setExpanded((d) => !d)}
          data-expanded={expanded}
        >
          {expanded ? <FiChevronDown /> : <FiChevronRight />}
          {engine.filterLabel(microcopy)}
        </a>
      </div>
      <div
        className={style.filters}
        data-expanded={expanded}
        data-collapsed={engine.state.collapsed}
        data-mobile={mobile}
      >
        <div data-left>
          <ul>
            <li
              onClick={() => engine.clearFilters()}
              data-selected={engine.hasDefaultFilters()}
            >
              <span>
                <FiSquare />
                <FiCheckSquare />
                {microcopy.text("changelog.all")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("all")}
                href="./all.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
          </ul>
          <ul>
            <li
              onClick={engine.toggleFilter("is_new_feature", true)}
              data-selected={engine.hasFilter("is_new_feature", true)}
            >
              <span>
                <FiSquare />
                <FiCheckSquare />
                {microcopy.text("changelog.levels.is_new_feature")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("new-features")}
                href="./new-features.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("is_impactful", true)}
              data-selected={engine.hasFilter("is_impactful", true)}
            >
              <span>
                <FiSquare />
                <FiCheckSquare />
                {microcopy.text("changelog.levels.is_impactful")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("impactful")}
                href="./impactful.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
          </ul>
        </div>
        <div data-right>
          <ul>
            <li
              onClick={engine.toggleFilter("label", "api")}
              data-selected={engine.hasFilter("label", "api")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.api")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:api")}
                href="./api.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "java")}
              data-selected={engine.hasFilter("label", "java")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.java")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:java")}
                href="./java.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "windows")}
              data-selected={engine.hasFilter("label", "windows")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.windows")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:windows")}
                href="./windows.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "python")}
              data-selected={engine.hasFilter("label", "python")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.python")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:python")}
                href="./python.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "node")}
              data-selected={engine.hasFilter("label", "node")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.node")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:node")}
                href="./node.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "cli")}
              data-selected={engine.hasFilter("label", "cli")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.cli")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:cli")}
                href="./cli.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "ios")}
              data-selected={engine.hasFilter("label", "ios")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.ios")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:ios")}
                href="./ios.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
            <li
              onClick={engine.toggleFilter("label", "ui-elements")}
              data-selected={engine.hasFilter("label", "ui-elements")}
            >
              <span>
                <FiCircle />
                <FiCheckCircle />
                {microcopy.text("changelog.labels.ui-elements")}
              </span>
              <OutboundLink
                data-rss
                onClick={event("label:ui-elements")}
                href="./ui-elements.xml"
                target="_blank"
              >
                <FiRss />
              </OutboundLink>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default Filters
